/** Every client-side path in one place. Never hard-code paths in components. */
export const ROUTES = {
  root: '/',
  login: '/login',
  dashboard: '/dashboard',
  documents: '/documents',
  documentUpload: '/documents/upload',
  users: '/admin/users',
  roles: '/admin/roles',
  apiClients: '/admin/api-keys',
  account: '/account',
  unauthorized: '/unauthorized',
} as const;

/** Review page of one uploaded form. */
export const documentPath = (id: number) => `${ROUTES.documents}/${id}`;
